

import { ServiceType } from './service-type';

export class PricingCopilotCustomOverviewMonthlyPerformanceChartTypeOptions {
	public chartOptions: any[] = [];

	constructor(serviceType?: ServiceType, displayUnits?: string) {
		this.chartOptions = [
			{
				label: 'overallAuctionParticipationRatio',
				options: {
					animationEnabled: true,
					backgroundColor: 'transparent',
					axisX: {
						valueFormatString: 'MMM YYYY',
						labelAngle: -45,
						labelFontSize: 14,
						labelFontWeight: '400',
						labelFontFamily: 'Oxygen, sans-serif',
						labelFontColor: '#999999',
						lineColor: '#d5dfec',
						tickColor: '#d5dfec',
						title: 'Add Date',
						titleFontSize: 14,
						titleFontWeight: '400',
						titleFontFamily: 'Oxygen, sans-serif',
						titleFontColor: '#000000',
					},
					axisY: {
						suffix: '%',
						labelFontSize: 14,
						labelFontWeight: '400',
						labelFontFamily: 'Oxygen, sans-serif',
						labelFontColor: '#999999',
						lineThickness: 0,
						lineColor: '#d5dfec',
						tickColor: '#d5dfec',
						gridColor: '#d5dfec',
					},
					toolTip: {
						cornerRadius: 8,
						borderColor: '#d5dfec',
						contentFormatter: function (e: any) {
							const date = e.entries[0].dataPoint.x;
							const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: '2-digit' };
							const formattedDate = date.toLocaleDateString('en-US', options);
							const value = e.entries[0].dataPoint.y;
							return (
								'<div style="padding:3px 5px;">' +
								'<span style="font-size:14px; line-height:22px;">' +
								formattedDate +
								'</span><br/>' +
								'<span style="font-size:14px; line-height:22px; color: #6c91a7;">' +
								value +
								'%</span>' +
								'</div>'
							);
						},
					},
					data: [
						{
							type: 'area',
							color: '#6c91a7',
							lineColor: '#6c91a7',
							fillOpacity: 0.15,
							dataPoints: [],
						},
					],
				}
			},
			{
				label: 'overallAuctionWinRatio',
				options: {
					animationEnabled: true,
					backgroundColor: 'transparent',
					axisX: {
						valueFormatString: 'MMM YYYY',
						labelAngle: -45,
						labelFontSize: 14,
						labelFontWeight: '400',
						labelFontFamily: 'Oxygen, sans-serif',
						labelFontColor: '#999999',
						lineColor: '#d5dfec',
						tickColor: '#d5dfec',
						title: 'Add Date',
						titleFontSize: 14,
						titleFontWeight: '400',
						titleFontFamily: 'Oxygen, sans-serif',
						titleFontColor: '#000000',
					},
					axisY: {
						suffix: '%',
						labelFontSize: 14,
						labelFontWeight: '400',
						labelFontFamily: 'Oxygen, sans-serif',
						labelFontColor: '#999999',
						lineThickness: 0,
						lineColor: '#d5dfec',
						tickColor: '#d5dfec',
						gridColor: '#d5dfec',
					},
					toolTip: {
						cornerRadius: 8,
						borderColor: '#d5dfec',
						contentFormatter: function (e: any) {
							const date = e.entries[0].dataPoint.x;
							const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: '2-digit' };
							const formattedDate = date.toLocaleDateString('en-US', options);
							const value = e.entries[0].dataPoint.y;
							return (
								'<div style="padding:3px 5px;">' +
								'<span style="font-size:14px; line-height:22px;">' +
								formattedDate +
								'</span><br/>' +
								'<span style="font-size:14px; line-height:22px; color: #009900;">' +
								value +
								'%</span>' +
								'</div>'
							);
						},
					},
					data: [
						{
							type: 'area',
							color: '#009900',
							lineColor: '#009900',
							fillOpacity: 0.15,
							dataPoints: [],
						},
					],
				},
			},
			{
				label: 'averageDelta',
				options: {
					animationEnabled: true,
					backgroundColor: 'transparent',
					axisX: {
						valueFormatString: 'MMM YYYY',
						labelAngle: -45,
						labelFontSize: 14,
						labelFontWeight: '400',
						labelFontFamily: 'Oxygen, sans-serif',
						labelFontColor: '#999999',
						lineColor: '#d5dfec',
						tickColor: '#d5dfec',
						title: 'Add Date',
						titleFontSize: 14,
						titleFontWeight: '400',
						titleFontFamily: 'Oxygen, sans-serif',
						titleFontColor: '#000000',
					},
					axisY: {
						labelFontSize: 14,
						labelFontWeight: '400',
						labelFontFamily: 'Oxygen, sans-serif',
						labelFontColor: '#999999',
						lineThickness: 0,
						lineColor: '#d5dfec',
						tickColor: '#d5dfec',
						gridColor: '#d5dfec',
						labelFormatter: function (e: any) {
							return e.value.toFixed(1) + ' ' + displayUnits;
						},
					},
					toolTip: {
						cornerRadius: 8,
						borderColor: '#d5dfec',
						contentFormatter: function (e: any) {
							const date = e.entries[0].dataPoint.x;
							const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: '2-digit' };
							const formattedDate = date.toLocaleDateString('en-US', options);
							const value = e.entries[0].dataPoint.y;
							return (
								'<div style="padding:3px 5px;">' +
								'<span style="font-size:14px; line-height:22px;">' +
								formattedDate +
								'</span><br/>' +
								'<span style="font-size:14px; line-height:22px; color: #fc8f3b;">' +
								value.toFixed(4) + ' ' + displayUnits +
								'</span>' +
								'</div>'
							);
						},
					},
					data: [
						{
							type: 'area',
							color: '#fc8f3b',
							lineColor: '#fc8f3b',
							fillOpacity: 0.15,
							dataPoints: [],
						},
					],
				}
			},
		];
	}
}
